import { Box, Container, Grid, Tab, Tabs, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import SurveyedItemTabForm from "./SurveyedItemTabForm";
import {
  setUpdateSurveyTabAction,
  updateSurveyTabAction,
} from "../../../../store/reducers/leadSurveySlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { calculateRoomVolume } from "./surveyUtils";

const SurveyedItemTab: FC<any> = ({
  disabledAction = false,
  subTabvalue = "0",
  setSubTabValue = () => {},
  contentRef,
  setSurveyFirstTabForm,
  isValueChanged,
  setIsValueChanged,
}) => {
  // const [value, setValue] = useState(0);
  const [tempValue, setTempValue] = useState(subTabvalue);
  const [surveyForm, setSurveyForm]: any = useState(null);
  const [error, setError] = useState(null);
  // const [isValueChanged, setIsValueChanged] = useState(false);
  const [load, setLoad] = useState(false);
  const { surveyRoomList, isSurveyTabSuccess, linkedItems, surveyedItems } =
    useSelector((state: any) => state.leadSurvey);
  const { leadDetails } = useSelector((state: any) => state.lead);
  const dispatch = useDispatch();
  const [localSurveyRoomList, setLocalSurveyRoomList] = useState(
    surveyRoomList || [],
  );

  /* -----------------------------------------------------------
       Merge surveyRoomList + surveyedItems rooms
    ------------------------------------------------------------ */

  useEffect(() => {
    if (surveyRoomList?.length) {
      let mergedRooms = [...surveyRoomList];

      if (surveyedItems?.list?.length) {
        surveyedItems.list.forEach((item: any) => {
          const exists = mergedRooms.find(
            (room: any) => room.room === item.name,
          );

          if (!exists) {
            mergedRooms.push({
              room: item.name,
              items: item.items || [],
            });
          }
        });
      }

      setLocalSurveyRoomList(mergedRooms);
    }
  }, [surveyRoomList, surveyedItems]);

  useEffect(() => {
    if (surveyForm) {
      setSurveyFirstTabForm(surveyForm);
    }
  }, [surveyForm]);

  useEffect(() => {
    setTempValue(subTabvalue);
    setLoad(false);
    setTimeout(() => {
      setLoad(true);
    }, 1000);
    // Scroll to the top of the content container
    if (contentRef.current) {
      contentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, [subTabvalue]);

  useEffect(() => {
    if (isSurveyTabSuccess) {
      setSubTabValue(tempValue);
      dispatch(setUpdateSurveyTabAction(false));
    }
  }, [isSurveyTabSuccess]);

  const tabValidator = (formData: any) => {
    let isError = false;
    let localError: any = {};
    formData?.map((item: any, index: any) => {
      if (!item?.item) {
        if (!item?.item) {
          console.log(
            "formData-",
            !(!item?.item && !item?.ft3 && !item?.quantity),
          );
          isError = true;
          if (localError) {
            localError[index] = true;
          } else {
            localError = { [index]: true };
          }
        }
      }
    });
    return { isError, localError };
  };
  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    if (isValueChanged) {
      const { isError, localError }: any = tabValidator(surveyForm);
      setError(localError);
      if (!isError) {
        dispatch(
          updateSurveyTabAction({
            tab: "tab3",
            surveyId: leadDetails?.lead?.survey_id,
            data: {
              name: surveyRoomList?.[subTabvalue]?.room,
              items: surveyForm,
            },
          }),
        );
        setTempValue(newValue);
        setIsValueChanged(false);
      }
    } else {
      setSubTabValue(newValue);
    }
  };

  const completedTab = (room: any) => {
    const filtered = surveyedItems?.list.find((ele: any) => ele?.name === room);
    if (filtered) {
      return "completed";
    } else {
      return "";
    }
  };

  return (
    <>
      <Grid container spacing={1} sx={{ marginTop: "5px" }}>
        <Grid
          item
          xs={2}
          sm={2}
          className="surveyTabContainer"
          sx={{ background: "#E5F4F1", padding: "12px", borderRadius: "5px" }}
        >
          <Container fixed sx={{ bgcolor: "#fff", padding: " 0px!important" }}>
            <Tabs
              value={subTabvalue}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
              variant="standard"
              orientation="vertical"
              sx={{
                background: "#E5F4F1",
                fontSize: "14px",
                fontWeight: 600,
                marginBottom: "16px",
                padding: 0,
              }}
            >
              {localSurveyRoomList &&
                localSurveyRoomList.map((tab: any, idx: any) => ({ tab, idx }))
                  .filter(({ tab }: any) => tab?.room !== "Materials")
                  .map(({ tab, idx }: any) => {
                  const roomData = surveyedItems?.list?.find(
                    (ele: any) => ele?.name === tab?.room,
                  );
                  const displayRoomName =
                    localSurveyRoomList?.[idx]?.roomName ||
                    roomData?.roomName ||
                    roomData?.name ||
                    tab?.room;
                  const roomVolume = calculateRoomVolume(roomData?.items || []);
                  return (
                    <Tab
                      value={idx}
                      label={
                        <>
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              // padding: "0px 8px",
                            }}
                          >
                            <Typography sx={{ fontSize: "14px" }}>
                              {displayRoomName}
                            </Typography>
                            {/* RIGHT SIDE */}
                            <Typography
                              sx={{
                                color: "#056c16",
                                fontWeight: 600,
                                fontSize: "12px",
                                textTransform: "lowercase",
                              }}
                            >
                              ({roomVolume} m³)
                            </Typography>
                          </Box>
                        </>
                      }
                      className={completedTab(tab?.room)}
                    />
                  );
                })}
            </Tabs>
          </Container>
        </Grid>
        <Grid item xs={10} sm={10} sx={{ padding: "0px 10px !important" }}>
          {load ? (
            <SurveyedItemTabForm
              data={localSurveyRoomList ? localSurveyRoomList[subTabvalue] : {}}
              elementId={subTabvalue}
              surveyForm={surveyForm}
              setSurveyForm={setSurveyForm}
              error={error}
              setError={setError}
              tabValidator={tabValidator}
              linkedItems={linkedItems}
              setIsValueChanged={setIsValueChanged}
              disabledAction={disabledAction}
            />
          ) : (
            "Loading..."
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default SurveyedItemTab;
